module.exports = __webpack_public_path__ + "img/infoImg2.768a4e33.png";